import om_1 from './om_1.jpg';
import om_2 from './om_2.jpg';
import om_3 from './om_3.jpg';
import om_4 from './om_4.jpg';
import om_5 from './om_5.jpg';
import om_6 from './om_6.jpg';
import om_7 from './om_7.png';
import om_8 from './om_8.png';
import om_9 from './om_9.png';
import om_10 from './om_10.png';
import om_11 from './om_11.png';
import om_12 from './om_12.png';

export default [
  undefined, om_1, om_2, om_3, om_4, om_5, om_6, om_7, om_8, om_9, om_10, om_11, om_12
]


// WEBPACK FOOTER //
// ./src/assets/img/llc/contact/om/index.js